<template lang="">
  <div id="content">
    <div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">게시판 관리</a> &gt; <strong>FAQ 관리</strong></div>
			<h2 class="h_sub">FAQ 리스트</h2>
		</div>

    <FaqManageListForm/>
  </div>
</template>

<script>
import FaqManageListForm from '@/components/admin/board/FaqManageListForm.vue';

export default {
  components: {
    FaqManageListForm
  }
}
</script>
<style lang="">
    
</style>